<template>
  <div class="auth-page">
    <div class="auth-page__wrapper">
      <div class="auth-block not-found__grid">
        <div class="auth-block__logo">
          <img
            class="auth-block__logo__image"
            :src="require(`@/assets/images/logo_${$config.styleName}.svg`)"
            width="121"
            height="93"
          >
          <span class="auth-block__logo__title">{{ $t('common.portal') }}</span>
        </div>
        <div class="header__name not-found__url">
          {{ $t('views.not_found.url_not_found') }}
        </div>
        <div class="not-found__link">
          <router-link
            class="not-found__text"
            :to="{name: 'SignIn'}"
            tag="span"
          >
            {{ $t('views.not_found.reroute_signin') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
.not-found {
  justify-content: center;

  &__link {
    align-items: flex-start;
  }

  &__text {
    color: var(--margaritas);
    cursor: pointer;
    border-bottom: 1px solid var(--margaritas);
    transition: 0.3s ease-in-out;
    transition-property: color, border-bottom-color;
    text-align: center;

    &:hover {
      color: var(--aurum);
      border-bottom-color: var(--aurum);
    }
  }

  &__grid {
    grid-template-rows: min-content auto 100px;
    justify-content: center;
  }

  &__url {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
}
</style>
